import { http } from "@/api";
const Qs = require("qs");
import ResulSetFactory from "@/factories/wind/diagnostic/ResultSetFactory";

/**
 * Chamada da api para obter resultados dos diagnósticos.
 * @param params parâmetros para requisição http.
 * - monitoringElementId id do elemento de monitoração ad turbina.
 * - startDateTime Data de inicio da pesquisa.
 * - endDateTime Data final da pesquisa.
 * @returns Promise da api para obter um objeto com Arrays de resultados de diagnósticos no período selecionado,
 *  com filtros para modos de falha.
 */
const GetWindDiagnosticResultSets = function(parameters = ResulSetFactory.ResultSetModel())
{
	const { monitoringElementId } = parameters;
	const qParams = { startDateTime: parameters.startDateTime, endDateTime: parameters.endDateTime };

	return http.get(`/ResultSets/${monitoringElementId}/Wind`, {
		params:           qParams,
		paramsSerializer: params => Qs.stringify(params, { encode: false }),
	});
};

/**
 * Chamada da api para obter resultados dos piores casos de cada diagnósticos.
 * @param params parâmetros para requisição http.
 * - monitoringElementId id do elemento de monitoração ad turbina.
 * - startDateTime Data de inicio da pesquisa.
 * - endDateTime Data final da pesquisa.
 * @returns Promise da api para obter um objeto com Arrays dos piores resultados de diagnósticos no período selecionado.
 */
const GetWindDiagnosticWorstResultSets = function(parameters = ResulSetFactory.ResultSetModel())
{
	const { monitoringElementId } = parameters;
	const qParams = { startDateTime: parameters.startDateTime, endDateTime: parameters.endDateTime };

	return http.get(`/ResultSets/${monitoringElementId}/Wind/WorstResultSet`, {
		params:           qParams,
		paramsSerializer: params => Qs.stringify(params, { encode: false }),
	});
};
export default { GetWindDiagnosticResultSets, GetWindDiagnosticWorstResultSets };